import React, { Component } from "react";
import Cookies from "universal-cookie";
import moment from "moment";
import { Buffer } from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import { orderService } from "../../services/otodisApi/OrderService";
import { Button, Col, DatePicker, Form, Input, Row, Modal } from "antd";
import { SaveOutlined, UndoOutlined } from "@ant-design/icons";
import { CreateDeliveryOrderManualStates } from "./types/CreateDeliveryOrderManualTypes";
import OtodisDeliveryDriverSelect from "../../components/otodis/OtodisDeliveryDriverSelect";
import OtodisDeliveryVehicleSelect from "../../components/otodis/OtodisDeliveryVehicleSelect";

export interface CreateDeliveryOrderManualProps {}

class CreateDeliveryOrderManual extends Component<CreateDeliveryOrderManualProps & any, CreateDeliveryOrderManualStates> {
  private readonly initState!: CreateDeliveryOrderManualStates;
  private uDealer = JSON.parse(Buffer.from(new Cookies().get("_d"), "base64").toString());
  private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());
  private token = new Cookies().get("_t");

  constructor(props: (CreateDeliveryOrderManualProps & any) | any) {
    super(props);

    const finalDealerCode = props.match.params.dealerCode.replace(/-/g, "#");

    this.initState = {
      processing: false,
      submitting: false,

      dealerSelected: [finalDealerCode],
      dealerCode: finalDealerCode,
      deliveryMethod: "MANUAL",
      orderCode: "",
      driverCode: "",
      driverName: "",
      deliveryDate: moment().clone().format("YYYY-MM-DD"),
      deliveryNumber: "",
      deliveryLicensePlate: "",
    };
    this.state = { ...this.initState };
  }

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      dealerCode: data.value,
      dealerSelected: [data.value],
      driverCode: null,
      driverName: null,
    });
  };

  onDriverChange = (data: any) => {
    console.log(this.state.dealerSelected);
    console.log(data);
    this.setState({
      driverCode: data.value,
      driverName: data.children,
    });
  };

  ondeliveryLicensePlateChange = (data: any) => {
    console.log(this.state.dealerSelected);
    console.log(data);
    this.setState({
      deliveryLicensePlate: data.value,
      // assetName: data.children,
    });
  };

  onStringFieldChange = <T extends keyof Pick<any, "companyCode" | "orderCode" | "deliveryDate" | "deliveryNumber" | "deliveryMethod">>(target: T, value: any) => {
    const currentState: any = { ...this.state };

    switch (target) {
      case "orderCode":
        currentState.orderCode = value;
        break;
      case "deliveryMethod":
        currentState.deliveryMethod = value;
        break;
      case "deliveryDate":
        currentState.deliveryDate = value;
        break;
      case "deliveryNumber":
        currentState.deliveryNumber = value;
        break;
    }

    this.setState({
      ...currentState,
    });
  };

  onReset = async () => {
    await this.promisedSetState({
      ...this.initState,
    });
  };

  onDeliveryManual = async () => {
    const currentState: any = { ...this.state };

    if (!currentState.dealerCode) {
      Modal.error({ title: "Error", content: "Invalid Dealer" });
      return;
    }
    if (!currentState.orderCode) {
      Modal.error({ title: "Error", content: "Invalid Order Code" });
      return;
    }
    if (!currentState.deliveryMethod) {
      Modal.error({ title: "Error", content: "Invalid Delivery Method" });
      return;
    }
    if (!currentState.deliveryNumber) {
      Modal.error({ title: "Error", content: "Invalid Delivery Number" });
      return;
    }
    if (!currentState.deliveryDate) {
      Modal.error({ title: "Error", content: "Invalid Delivery Date" });
      return;
    }
    if (!currentState.driverCode) {
      Modal.error({ title: "Error", content: "Invalid Driver Code" });
      return;
    }
    if (!currentState.deliveryLicensePlate) {
      Modal.error({ title: "Error", content: "Invalid Delivery License Plate" });
      return;
    }

    this.setState({ submitting: true });

    const input = {
      dealer_code: currentState.dealerCode,
      order_code: currentState.orderCode,
      delivery_method: currentState.deliveryMethod,
      delivery_number: currentState.deliveryNumber,
      delivery_date: currentState.deliveryDate,
      driver_code: currentState.driverCode,
      driver_name: currentState.driverName,
      delivery_license_plate: currentState.deliveryLicensePlate,
      updated_by: this.user,
    };

    try {
      orderService.setToken(this.token);
      await orderService.deliveryManual(input).then((result) => {
        Modal.success({
          title: "Proses Sukses",
          content: result?.data?.message,
        });

        this.onReset();
      });
    } catch (e: any) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda :" + e.message,
      });
      await this.promisedSetState({
        submitting: false,
      });
    }
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Delivery`}
          breadcrumbMenu={`Buat Delivery Manual`}
          defaultSelectedKeys={["m-create-delivery-manual"]}
          defaultOpenKeys={["sm-delivery"]}
        >
          <Form layout={"vertical"}>
            <Row>
              <Col xl={{ span: 18 }} lg={{ span: 18 }} md={{ span: 18 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Order Code <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Input type="text" value={this.state.orderCode} placeholder="Order Code" onChange={(event) => this.onStringFieldChange("orderCode", event.target.value)} />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Metode Pengiriman <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Input type="text" value={this.state.deliveryMethod} placeholder="Metode Pengiriman" onChange={(event) => this.onStringFieldChange("deliveryMethod", event.target.value)} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        No Pengiriman <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Input type="text" value={this.state.deliveryNumber} placeholder="No Pengiriman" onChange={(event) => this.onStringFieldChange("deliveryNumber", event.target.value)} />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Tanggal Pengiriman <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <DatePicker
                        value={moment(this.state.deliveryDate, "YYYY-MM-DD")}
                        format={"YYYY-MM-DD"}
                        style={{ width: "100%" }}
                        onChange={(date, dateString) => this.onStringFieldChange("deliveryDate", dateString)}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Sopir <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <OtodisDeliveryDriverSelect onDriverChangeProps={this.onDriverChange} dealerCode={this.state.dealerCode} value={this.state.driverCode} />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        No Polisi Kendaraan <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <OtodisDeliveryVehicleSelect onAssetChangeProps={this.ondeliveryLicensePlateChange} dealerCode={this.state.dealerCode} value={this.state.deliveryLicensePlate} />
                    </Form.Item>
                  </Col>
                </Row>
                <br />{" "}
              </Col>
            </Row>

            <Row>
              <Col xl={{ span: 6 }} lg={{ span: 8 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                    <Button type={"primary"} icon={<SaveOutlined />} loading={this.state.submitting} onClick={this.onDeliveryManual} style={{ width: "100%" }}>
                      Simpan Data
                    </Button>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                    <Button type={"primary"} danger icon={<UndoOutlined />} onClick={this.onReset} loading={this.state.submitting} style={{ width: "100%" }}>
                      Reset Form
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(CreateDeliveryOrderManual), 52);
